export default "__VITE_ASSET__BgvE$iM8__"